"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSearch = void 0;
const downshift_1 = require("downshift");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const locationSearchIcon_svg_1 = __importDefault(require("../../../assets/icons/locationSearchIcon.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const cityPersistTimeout_1 = require("../../../utils/cityPersistTimeout");
const extractPrimaryCity_1 = require("../../../utils/extractPrimaryCity");
const geolocation_1 = require("../../../utils/geolocation");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const trackCityEvent_1 = require("../../../utils/trackCityEvent");
const trackRecentSearch_1 = require("../../../utils/trackRecentSearch");
const useAutocompleteSuggestions_1 = __importDefault(require("../../../utils/useAutocompleteSuggestions"));
const useRecentSearches_1 = __importDefault(require("../../../utils/useRecentSearches"));
const S = __importStar(require("./LocationSearch.style"));
const isRecent = (item) => "lat" in item && "lng" in item;
const renderHighlightedLabel = (text, ranges) => {
    if (!ranges || ranges.length === 0)
        return text;
    const sorted = [...ranges]
        .filter((r) => r.end > r.start && r.start < text.length)
        .sort((a, b) => a.start - b.start);
    const parts = [];
    let cursor = 0;
    sorted.forEach((range, idx) => {
        const safeStart = Math.max(range.start, cursor);
        const safeEnd = Math.min(range.end, text.length);
        if (safeStart > cursor) {
            parts.push(text.slice(cursor, safeStart));
        }
        if (safeEnd > safeStart) {
            parts.push(react_1.default.createElement(S.Highlight, { key: `hl-${idx}` }, text.slice(safeStart, safeEnd)));
        }
        cursor = safeEnd;
    });
    if (cursor < text.length) {
        parts.push(text.slice(cursor));
    }
    return parts;
};
const serializeBounds = (bounds) => {
    if (!bounds)
        return undefined;
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    return {
        north: ne.lat(),
        south: sw.lat(),
        east: ne.lng(),
        west: sw.lng(),
    };
};
const boundsStableKey = (b) => {
    var _a, _b;
    if (!b)
        return "__none__";
    try {
        return JSON.stringify((_b = (_a = b.toJSON) === null || _a === void 0 ? void 0 : _a.call(b)) !== null && _b !== void 0 ? _b : null);
    }
    catch (_c) {
        return "__unknown__";
    }
};
const LocationSearch = ({ isTimelapseView }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const { t } = (0, react_i18next_1.useTranslation)();
    const map = (0, react_google_maps_1.useMap)();
    const { setUrlParams, removeCityParam } = (0, mapParamsHandler_1.useMapParams)();
    const lastBiasKeyRef = (0, react_1.useRef)("__init__");
    const [locationBias, setLocationBias] = (0, react_1.useState)(null);
    const justSelectedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => () => (0, cityPersistTimeout_1.resetCitySettle)(), []);
    (0, react_1.useEffect)(() => {
        if (!map) {
            lastBiasKeyRef.current = "__init__";
            setLocationBias(null);
            return;
        }
        const syncBias = () => {
            var _a, _b;
            const b = (_b = (_a = map.getBounds) === null || _a === void 0 ? void 0 : _a.call(map)) !== null && _b !== void 0 ? _b : null;
            const key = boundsStableKey(b);
            if (key === lastBiasKeyRef.current)
                return;
            lastBiasKeyRef.current = key;
            setLocationBias(b);
        };
        syncBias();
        const listener = map.addListener("idle", syncBias);
        return () => {
            listener.remove();
            lastBiasKeyRef.current = "__init__";
        };
    }, [map]);
    const { setInput, suggestions, status, selectSuggestion } = (0, useAutocompleteSuggestions_1.default)({ locationBias });
    const { recents, addRecent, clearRecents } = (0, useRecentSearches_1.default)();
    const showingRecents = inputValue.trim() === "" && recents.length > 0;
    const items = showingRecents
        ? recents
        : status === "ok"
            ? suggestions
            : [];
    const liveMessage = (() => {
        if (showingRecents)
            return "";
        if (status === "loading")
            return t("map.statusLoading");
        if (status === "no_results")
            return t("map.statusNoResults");
        if (status === "error")
            return t("map.statusError");
        if (status === "ok" && suggestions.length > 0) {
            return t("map.statusResultsAvailable", { count: suggestions.length });
        }
        return "";
    })();
    const applyMapNavigation = (target, cityLabel) => {
        const { lat, lng, zoom, bounds } = target;
        const cityPrimary = (0, extractPrimaryCity_1.extractPrimaryCity)(cityLabel);
        (0, cityPersistTimeout_1.armCitySettle)();
        setUrlParams([
            {
                key: mapParamsHandler_1.UrlParamsTypes.currentCenter,
                value: JSON.stringify({ lat, lng }),
            },
            {
                key: mapParamsHandler_1.UrlParamsTypes.currentZoom,
                value: zoom.toString(),
            },
            {
                key: mapParamsHandler_1.UrlParamsTypes.city,
                value: cityPrimary,
            },
        ]);
        if (bounds && map) {
            map.fitBounds(bounds);
        }
        else {
            map === null || map === void 0 ? void 0 : map.setZoom(zoom);
            map === null || map === void 0 ? void 0 : map.panTo({ lat, lng });
        }
        setTimeout(() => {
            dispatch((0, mapSlice_1.setFetchingData)(true));
        }, 200);
    };
    const handleSelect = (item) => __awaiter(void 0, void 0, void 0, function* () {
        if (!item)
            return;
        if (!isRecent(item) && status === "loading")
            return;
        if (isRecent(item)) {
            const position = recents.findIndex((r) => r.id === item.id);
            (0, trackCityEvent_1.trackCityEvent)({
                city: (0, extractPrimaryCity_1.extractPrimaryCity)(item.label),
                cityRaw: item.label,
                source: "recent",
                lat: item.lat,
                lng: item.lng,
                placeId: item.id,
            });
            (0, trackRecentSearch_1.trackRecentSearchUsed)({
                query: item.label,
                position: position === -1 ? 0 : position,
                totalRecents: recents.length,
            });
            applyMapNavigation(item, item.label);
            addRecent(item);
            return;
        }
        const result = yield selectSuggestion(item.id);
        if (!result)
            return;
        (0, trackCityEvent_1.trackCityEvent)({
            city: (0, extractPrimaryCity_1.extractPrimaryCity)(item.label),
            cityRaw: item.label,
            source: "autocomplete",
            lat: result.lat,
            lng: result.lng,
            placeId: item.id,
        });
        applyMapNavigation(result, item.label);
        addRecent({
            id: item.id,
            label: item.label,
            lat: result.lat,
            lng: result.lng,
            zoom: result.zoom,
            bounds: serializeBounds(result.bounds),
        });
    });
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps, } = (0, downshift_1.useCombobox)({
        onInputValueChange: ({ inputValue: newInputValue }) => {
            setInputValue(newInputValue);
            if (justSelectedRef.current) {
                justSelectedRef.current = false;
                return;
            }
            setInput(newInputValue);
        },
        items,
        itemToString(item) {
            return item ? item.label : "";
        },
        selectedItem,
        stateReducer: (state, { type, changes }) => {
            const isEnterWithoutHighlight = type === downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter &&
                state.highlightedIndex === -1 &&
                items.length > 0;
            const nextChanges = isEnterWithoutHighlight
                ? Object.assign(Object.assign({}, changes), { highlightedIndex: 0, selectedItem: items[0], inputValue: items[0].label, isOpen: false }) : changes;
            if (nextChanges.selectedItem &&
                nextChanges.selectedItem !== state.selectedItem) {
                justSelectedRef.current = true;
            }
            return nextChanges;
        },
        onSelectedItemChange: ({ selectedItem: newSelectedItem }) => {
            setSelectedItem(newSelectedItem);
            if (!newSelectedItem)
                return;
            if (!isRecent(newSelectedItem) && status === "loading")
                return;
            void handleSelect(newSelectedItem);
        },
        inputValue,
    });
    const showSpinner = status === "loading" && inputValue.trim().length > 0;
    const showClearButton = inputValue.length > 0 && !showSpinner;
    const showEmptyState = isOpen &&
        !showingRecents &&
        status === "no_results" &&
        inputValue.trim().length > 0;
    const showErrorState = isOpen && !showingRecents && status === "error";
    const displaySearchResults = isOpen && (items.length > 0 || showEmptyState || showErrorState);
    const handleBrowserLocation = () => __awaiter(void 0, void 0, void 0, function* () {
        const location = yield (0, geolocation_1.getBrowserLocation)(map, setUrlParams);
        if (location) {
            removeCityParam();
            setInputValue("");
            setInput("");
            setTimeout(() => {
                dispatch((0, mapSlice_1.setFetchingData)(true));
            }, 200);
        }
        else {
            console.warn(t("map.locationError"));
        }
    });
    const handleClearInput = () => {
        setInputValue("");
        setInput("");
        setSelectedItem(null);
        removeCityParam();
    };
    return (react_1.default.createElement(S.SearchContainer, { "$isTimelapseView": isTimelapseView },
        react_1.default.createElement(S.InputWrapper, null,
            react_1.default.createElement(S.SearchInput, Object.assign({ placeholder: t("map.searchPlaceholder"), "$displaySearchResults": displaySearchResults }, getInputProps({
                "aria-label": t("map.searchInputLabel"),
            }))),
            showSpinner && react_1.default.createElement(S.Spinner, { "aria-hidden": "true" }),
            showClearButton && (react_1.default.createElement(S.ClearInputButton, { type: "button", "aria-label": t("map.clearInputAriaLabel"), onMouseDown: (e) => e.preventDefault(), onClick: handleClearInput }, "\u00D7"))),
        react_1.default.createElement(S.LocationSearchButton, { "aria-label": t("map.browserLocationButton"), type: "button", onClick: handleBrowserLocation },
            react_1.default.createElement(S.LocationSearchIcon, { src: locationSearchIcon_svg_1.default, alt: "", "aria-hidden": "true" })),
        react_1.default.createElement(S.LiveRegion, { role: "status", "aria-live": "polite", "aria-atomic": "true" }, liveMessage),
        react_1.default.createElement(S.SuggestionsList, Object.assign({ "$displaySearchResults": displaySearchResults }, getMenuProps()),
            react_1.default.createElement(S.Hr, { "$displaySearchResults": displaySearchResults, "aria-hidden": "true" }),
            isOpen && showingRecents && (react_1.default.createElement(S.RecentSectionHeader, null,
                react_1.default.createElement(S.RecentSectionLabel, null, t("map.recentSearchesLabel")),
                react_1.default.createElement(S.ClearRecentsButton, { type: "button", "aria-label": t("map.clearRecentSearchesAriaLabel"), onMouseDown: (e) => e.preventDefault(), onClick: clearRecents }, t("map.clearRecentSearches")))),
            showEmptyState && (react_1.default.createElement(S.EmptyState, null, t("map.statusNoResults"))),
            showErrorState && (react_1.default.createElement(S.ErrorState, null, t("map.statusError"))),
            isOpen &&
                items.map((item, index) => {
                    const labelNode = !showingRecents && "matchRanges" in item
                        ? renderHighlightedLabel(item.label, item.matchRanges)
                        : item.label;
                    return (react_1.default.createElement(S.Suggestion, Object.assign({ key: item.id, "$isHighlighted": highlightedIndex === index }, getItemProps({
                        item,
                        index,
                        "aria-label": showingRecents
                            ? `${item.label}, ${t("map.recentSearchesLabel").toLowerCase()}`
                            : item.label,
                    })),
                        react_1.default.createElement(S.SuggestionLabel, null, labelNode)));
                }))));
};
exports.LocationSearch = LocationSearch;
